var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconGift = function SvgIconGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#404040",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4.79 11.519v7.684c0 .51.19.998.528 1.358s.797.563 1.275.563h10.814c.479 0 .937-.203 1.275-.563s.528-.849.528-1.358v-7.684"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#404040",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 6.237c0-.892-.332-1.747-.924-2.377a3.06 3.06 0 0 0-2.23-.985c-.598 0-1.17.253-1.593.703a2.48 2.48 0 0 0-.66 1.698c0 .637.237 1.248.66 1.698.422.45.995.703 1.593.703H12m0-1.44v1.44m0-1.44c0-.892.332-1.747.924-2.377a3.06 3.06 0 0 1 2.23-.985c.598 0 1.171.253 1.594.703.422.45.66 1.061.66 1.698 0 .316-.059.628-.172.92-.113.29-.28.555-.488.778-.21.223-.458.4-.731.52a2.1 2.1 0 0 1-.863.183H12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#404040",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 11.52v9.605M3.889 7.678H20.11v3.842H3.89zq0 0 0 0"
  })));
};
export default SvgIconGift;